import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Menu, Icon } from 'semantic-ui-react';

import { signOut } from '../../actions/signOut';

class Navigation extends Component {

    onClickDashboard() {
        this.props.history.push("/")
    }

    onClickContests() {
        this.props.history.push("/zgloszenia")
    }

    onClickParticipants() {
        this.props.history.push("/zawodnicy")
    }

    onClickSignOut() {
        this.props.dispatch(signOut());
    }

    render() {
        return (
            <Menu stackable icon='labeled'>
                <Menu.Item onClick={(e) => {this.onClickContests(e)}}><Icon name='trophy' /> Zgłoszenia</Menu.Item>
                <Menu.Item onClick={(e) => {this.onClickParticipants(e)}}><Icon name='users' /> Zawodnicy</Menu.Item>
                <Menu.Menu position='right'>
                    <Menu.Item onClick={(e) => {this.onClickSignOut(e)}}><Icon name='sign out' /> Wyloguj</Menu.Item>                
                </Menu.Menu>
            </Menu>
        );
    }
}

function mapStateToProps(state) {
    return {
    }
}

export default withRouter(connect(mapStateToProps)(Navigation))



// WEBPACK FOOTER //
// ./src/components/common/Navigation.js